var render = function render(){var _vm=this,_c=_vm._self._c;return _c('reseller-form',{staticClass:"basket-reselleroptions",attrs:{"controls":_vm.controls,"eventsOnly":""},on:{"form:change":_vm.onChange,"form:submit":_vm.onChange},scopedSlots:_vm._u([{key:"default",fn:function(formSlotProps){return [_vm._t("default",null,null,formSlotProps)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }